export default "__VITE_ASSET__ff215000__"